import { DefineComponent } from 'vue';

export type VariantsPaths = [
    Record<string, () => Promise<DefineComponent>>,
    string,
];

const variantsPaths: VariantsPaths[] = [
    [
        import.meta.glob<DefineComponent>(
            '/vendor/kibokosrl/kiboko-backoffice-cantine/resources/js/Components/Variants/**/*.vue',
        ),
        '/vendor/kibokosrl/kiboko-backoffice-cantine/resources/js/Components/Variants/',
    ],
];

export default variantsPaths;
